/*
 * Copyright (c) to Energy Analytics & Solutions Pty Ltd. All rights reserved.
 */
/* Author: Nikhil
   Purpose: Navbar on homepage
   Date: 5th January 2023
***************************************************************************
Changes/ enhancements
16-JAN-2024 EAS-439: Change book a demo link to hubspot from calendly - Nikhil P
***************************************************************************
*/


import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import $ from "jquery";

import logo from "../../assets/Images/eas_logo_final-02.png";

import sha256 from "crypto-js/sha256";
import axios from "axios";
import { Modal, Form, Button } from "react-bootstrap";
import { Alert } from "@mui/material";

import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";

const Navs = () => {
  const location = useLocation();

  const [flag, setflag] = useState("");
  const [showLogin, setShowLogin] = useState(false);
  const [errorState, setErrorState] = useState({
    errMsg: "",
    severity: "error",
  });
  const [mailerState, setMailerState] = useState({
    email: "",
    password: "",
  });
  const handleOpenLogin = () => {
    setShowLogin(true);
    setflag("/membershiplogin");
    $(elementRef.current).removeClass("show");
  };
  const handleClose = () => {
    setShowLogin(false);
  };

  function handleStateChange(e) {
    setMailerState((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  }

  const handleLogin = async (event) => {
    event.preventDefault();
    document.getElementById("submitLogin").disabled = true;
    mailerState.password = sha256(mailerState.password).toString();
    let email = mailerState.email;
    let password = mailerState.password;
    await axios
      .post(
        // `https://eascustomerdashboardbackend-new-twxnie6xwq-km.a.run.app/api/user/login`,
        // `https://backend.energyanalyticssolutions.com/api/v1/users/login`,
        // `http://localhost:3000/api/user/login`,
        `${process.env.REACT_APP_BACKEND_URL}/api/user/login`,
        {
          email,
          password,
        },
        {
          validateStatus: false,
        }
      )
      .then((res) => {
        const { token } = res.data;
        console.log(token);
        if (res.status === 200) {
          window.location.href = `${process.env.REACT_APP_LOGIN_LINK}/?token=${token}`;
        } else {
          document.getElementById("submitLogin").disabled = false;
          if (res.status === 404) {
            setErrorState({
              errMsg:
                "Looks like you are not registered with us please contact administrator",
              severity: "error",
            });
          } else {
            setErrorState({
              errMsg: res.data.message,
              severity: "error",
            });
          }
        }
      })
      .catch((error) => {
        document.getElementById("submitLogin").disabled = false;
        console.log(error);
      });
  };

  const elementRef = useRef(null);

  const navigate = useNavigate();
  useEffect(() => {
    setflag(location.pathname);
  }, []);

  const handleHome = () => {
    navigate("/");
    setflag("/");
    $(elementRef.current).removeClass("show");
  };
  const handleAbout = () => {
    navigate("/about");
    setflag("/about");
    $(elementRef.current).removeClass("show");
  };
  const handleServices = () => {
    navigate("/services");
    setflag("/services");
    $(elementRef.current).removeClass("show");
  };
  const handleContact = () => {
    navigate("/contact");
    setflag("/contact");
    $(elementRef.current).removeClass("show");
  };
  return (
    <>
      <Navbar collapseOnSelect expand="lg" className="bg-body-tertiary">
        <Container>
          <Navbar.Brand href="#home">
            <div className="navbarContainerLogo mx-4">
              <img src={logo} alt="logo" onClick={handleHome} />
            </div>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav" ref={elementRef}>
            <Nav className="me-auto"></Nav>
            <Nav>
              <li
                className={`navbarLink mx-2 ${flag === "/" ? "active" : ""}`}
                onClick={handleHome}
              >
                {" "}
                HOME
              </li>
              <li
                className={`navbarLink mx-2 ${
                  flag === "/about" ? "active" : ""
                }`}
                onClick={handleAbout}
              >
                ABOUT
              </li>
              <li
                className={`navbarLink mx-2 ${
                  flag === "/services" ? "active" : ""
                }`}
                onClick={handleServices}
              >
                SERVICES
              </li>
              <li
                className={`navbarLink mx-2 ${
                  flag === "/contact" ? "active" : ""
                }`}
                onClick={handleContact}
              >
                CONTACT US
              </li>
              {/* will open it later for login functionality */}
              <li
                className={`navbarLink mx-2 ${
                  flag === "/membershiplogin" ? "active" : ""
                }`}
                onClick={handleOpenLogin}
              >
                <a>MEMBER LOGIN</a>
              </li>
              <span className="navbarLink mx-2 border1">
              {/* ********************************EAS-439 Start************************************* */}
              {/* <a
                  href="https://calendly.com/energyanalyticssolutions/book-a-time-with-ash"
                  target="_blank"
                  rel="noreferrer"
                > */}
                <a
                  href="https://meetings.hubspot.com/ashley-mahadeo"
                  target="_blank"
                  rel="noreferrer"
                >
                  {/* ********************************EAS-439 End************************************* */}
                  BOOK A DEMO
                </a>

              </span>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      {/* model */}
      <Modal show={showLogin} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Login</Modal.Title>
        </Modal.Header>
        <div>
          {errorState.errMsg && (
            <Alert
              onClose={() => {
                setErrorState({
                  ...errorState,
                  errMsg: "",
                });
              }}
              severity={errorState.severity}
            >
              {errorState.errMsg}
            </Alert>
          )}
        </div>
        <Form>
          <Modal.Body>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="email"
                name="email"
                placeholder="name@example.com"
                value={mailerState.email}
                onChange={handleStateChange}
                required
              />
            </Form.Group>
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>Password</Form.Label>
              <Form.Control
                onChange={handleStateChange}
                type="password"
                rows={3}
                placeholder="Password"
                name="password"
                value={mailerState.password}
                required
              />
            </Form.Group>

            <Link to="/forgot-pwd" onClick={handleClose}>
              Forget the password?
            </Link>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button
              type="submit"
              style={{
                backgroundColor: "#2e3192",
              }}
              variant="primary"
              id="submitLogin"
              onClick={handleLogin}
              disabled={!mailerState.password || !mailerState.email}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};
export default Navs;
/*
 * Copyright (c) to Energy Analytics & Solutions Pty Ltd. All rights reserved.
 */
